import React, { useState, useEffect } from 'react'
import styled, { keyframes } from 'styled-components'
import { handleEventLog } from '../../../lib/utils'
import { getImageUrl } from '../../../lib/utils/convertCanvasToImage'
import { uploadFile } from '../../Shows/Novels/CreateNew'
import Loader from '../../../components/Loader'

const arrowMove = keyframes`
  0%, 100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(5px);
  }
`

const MainDiv = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  z-index: 5000;
  background-color: white;
`
const Story = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  background-color: ${({ bgColor }) => bgColor};
  padding: 16px;
`
const NextBtnContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`
const NextBtn = styled.button`
  position: absolute;
  bottom: 120px;
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 226px;
  background: ${({ bg }) => bg || 'rgba(255, 255, 255, 0.2)'};
  color: ${({ color }) => color || '#FFF'};
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 1.12px;
  padding: 11px 17px;
  outline: none;
  border: none;
  transition: transform 0.2s ease;
  z-index: 20;

  &:active {
    transform: scale(0.9);
  }

  img {
    animation: ${arrowMove} 1s ease-in-out infinite;
  }
`

const StoryOrderBoxes = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 10px;
  padding: 2px 0;
  gap: 8px;
  margin: 16px 0;
`

const StoryBox = styled.div`
  height: 6px;
  border-radius: 200px;
  width: 100%;
  background: ${({ on }) => (on ? '#FFF' : 'rgba(255, 255, 255, 0.30)')};
`

const StoryHeading = styled.div`
  display: flex;
  align-items: center;
  margin: 24px 0;
  gap: 10px;
  div {
    background: ${({ bg }) => bg || '#ffffff80'};
    color: ${({ color }) => color || '#FFF'};
    height: 36px;
    width: 36px;
    border-radius: 8px;
    font-size: 20px;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  h1 {
    color: ${({ color }) => color || '#FFF'};
    font-family: 'Unna';
    font-size: 28px;
    font-weight: 700;
  }
`

const StoryHead2 = styled.h2`
  color: ${({ color }) => color || '#FFF'};
  font-family: 'ITF Devanagari';
  font-size: ${({ fs }) => fs || '26px'};
  font-weight: 700;
  margin: 16px 0;
  span {
    font-family: 'ITF Devanagari';
  }
`

const StoryHead3 = styled.h3`
  color: ${({ color }) => color || '#FFF'};
  font-family: 'ITF Devanagari';
  font-size: 20px;
  font-weight: 400;
  span {
    font-family: 'ITF Devanagari';
  }
`

const CTABtn = styled.button`
  position: absolute;
  border-radius: 6px;
  background: ${({ bg }) => bg || '#FFF'};
  border: none;
  outline: none;
  color: ${({ color }) => color};
  font-size: 14px;
  font-weight: 700;
  width: calc(100% - 32px);
  height: 60px;
  bottom: 16px;
  left: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  z-index: 20;
`

const StoryImage = styled.div`
  position: relative;
`
const LeftDiv = styled.div`
  position: absolute;
  width: 50%;
  height: 500px;
  left: 0;
  top: -30%;
  z-index: 10;
`
const RightDiv = styled.div`
  position: absolute;
  width: 50%;
  height: 500px;
  right: 0;
  top: -30%;
  z-index: 10;
`
const HindiStory1Img = styled(StoryImage)`
  height: 40vh;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 80%;
  }
`
const HindiStory2Img = styled(StoryImage)`
  height: 45vh;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 80%;
  }
`
const HindiStory3Img = styled(StoryImage)`
  height: 55vh;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 75%;
  }
`
const EnglishStory1Img = styled(StoryImage)`
  height: 40vh;
  display: flex;
  align-items: center;
  img {
    width: 100vw;
    position: relative;
    margin: 30px 0;
    left: -16px;
  }
`

const EnglishStory2Img = styled(StoryImage)`
  img {
    width: 100%;
  }
`

const EnglishStory3Img = styled(StoryImage)`
  height: 45vh;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 90%;
  }
`
const EnglishStory4Img = styled(StoryImage)`
  height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    margin: 20px 0 0 10px;
  }
`

const HindiStory1 = ({
  handleStoryChange = () => {},
  handleStartWritingCTA,
  isLoading
}) => {
  return (
    <Story bgColor="#D11D4A">
      <StoryOrderBoxes>
        <StoryBox on />
        <StoryBox />
        <StoryBox />
      </StoryOrderBoxes>
      <StoryHeading>
        <div>1</div> <h1>Anyone can write</h1>
      </StoryHeading>
      <StoryHead2>लिखेगा इंडिया, तो बढ़ेगा इंडिया</StoryHead2>
      <StoryHead3>6 लाख पाठकों ने किया अपना लेखक बनने का सफ़र शुरू</StoryHead3>
      <HindiStory1Img>
        <LeftDiv onClick={() => handleStoryChange('prev')} ></LeftDiv>
        <RightDiv onClick={() => handleStoryChange('next')}></RightDiv>
        <img
          src="https://djhonz7dexnot.cloudfront.net/25edb722b6a74be788c5eda1fcc8a8c27600c98b.png"
          alt="Anyone Can Write"
        />
      </HindiStory1Img>
      <NextBtnContainer>
        <NextBtn type="button" onClick={() => handleStoryChange('next')}>
          NEXT <img src="/images/next_arrow.svg" alt=">>" />
        </NextBtn>
      </NextBtnContainer>
      <CTABtn color="#DE5357" onClick={handleStartWritingCTA}>
        {isLoading ? <Loader size="sm" noPadding /> : (<><img src="/images/writing_hand_red.svg" alt="✍🏼" /> Start Writing</>)}
      </CTABtn>
    </Story>
  )
}
const HindiStory2 = ({
  handleStoryChange = () => {},
  handleStartWritingCTA,
  isLoading
}) => {
  return (
    <Story bgColor="#006B28">
      <StoryOrderBoxes>
        <StoryBox />
        <StoryBox on />
        <StoryBox />
      </StoryOrderBoxes>
      <StoryHeading>
        <div>2</div> <h1>Write & earn money</h1>
      </StoryHeading>
      <StoryHead2>हाँ, पैसे पेड़ पर उगते हैं</StoryHead2>
      <StoryHead3>लेकिन पतझड़ तो लिखने के बाद ही होती है</StoryHead3>
      <HindiStory2Img>
        <LeftDiv onClick={() => handleStoryChange('prev')} ></LeftDiv>
        <RightDiv onClick={() => handleStoryChange('next')}></RightDiv>
        <img
          src="https://djhonz7dexnot.cloudfront.net/e12bd6b4b8e8d8d643ff7562f6fe52249fba1000.png"
          alt="Write & Earn Money"
        />
      </HindiStory2Img>
      <NextBtnContainer>
        <NextBtn type="button" onClick={() => handleStoryChange('next')}>
          NEXT <img src="/images/next_arrow.svg" alt=">>" />
        </NextBtn>
      </NextBtnContainer>
      <CTABtn color="#02762D" onClick={handleStartWritingCTA}>
        {isLoading ? <Loader size="sm" noPadding /> : (<><img src="/images/writing_hand_green.svg" alt="✍🏼" /> Start Writing</>)}
      </CTABtn>
    </Story>
  )
}
const HindiStory3 = ({ handleStartWritingCTA, isLoading, handleStoryChange }) => {
  return (
    <Story bgColor="#E99F30">
      <StoryOrderBoxes>
        <StoryBox />
        <StoryBox />
        <StoryBox on />
      </StoryOrderBoxes>
      <StoryHeading>
        <div>3</div> <h1>Build a fan base</h1>
      </StoryHeading>
      <StoryHead2>पापा कहते है बड़ा नाम करेगा</StoryHead2>
      <StoryHead3>
        Pocket Novel पर लिखो और करो कहनियों की दुनिया में बड़ा नाम
      </StoryHead3>
      <HindiStory3Img>
        <LeftDiv onClick={() => handleStoryChange('prev')} ></LeftDiv>
        <RightDiv onClick={() => handleStoryChange('next')}></RightDiv>
        <img
          src="https://djhonz7dexnot.cloudfront.net/a43cffa0f20e410872e8bb6cb68d8af752c135fb.png"
          alt="Build a Fan Base"
        />
      </HindiStory3Img>
      <CTABtn color="#955E00" onClick={handleStartWritingCTA}>
        {isLoading ? <Loader size="sm" noPadding /> : (<><img src="/images/writing_hand_yellow.svg" alt="✍🏼" /> Start Writing</>)}
      </CTABtn>
    </Story>
  )
}
const EnglishStory1 = ({
  handleStoryChange = () => {},
  handleStartWritingCTA,
  isLoading
}) => {
  return (
    <Story bgColor="#E51A4D">
      <StoryOrderBoxes>
        <StoryBox on />
        <StoryBox />
        <StoryBox />
        <StoryBox />
      </StoryOrderBoxes>
      <StoryHeading>
        <div>1</div> <h1>You can write too</h1>
      </StoryHeading>
      <StoryHead2 fs="30px">10,000 Listeners turned to storytellers</StoryHead2>
      <StoryHead3>What are you waiting for...</StoryHead3>
      <EnglishStory1Img>
        <LeftDiv onClick={() => handleStoryChange('prev')} ></LeftDiv>
        <RightDiv onClick={() => handleStoryChange('next')}></RightDiv>
        <img
          src="https://djhonz7dexnot.cloudfront.net/1eab0dd764a1344837c788971602071c586f3ea4.png"
          alt="You Can write too"
        />
      </EnglishStory1Img>
      <NextBtnContainer>
        <NextBtn type="button" onClick={() => handleStoryChange('next')}>
          NEXT <img src="/images/next_arrow.svg" alt=">>" />
        </NextBtn>
      </NextBtnContainer>
      <CTABtn color="#E51A4D" onClick={handleStartWritingCTA}>
        {isLoading ? <Loader size="sm" noPadding /> : (<><img src="/images/writing_hand_red.svg" alt="✍🏼" /> Start Writing</>)}
      </CTABtn>
    </Story>
  )
}
const EnglishStory2 = ({
  handleStoryChange = () => {},
  handleStartWritingCTA,
  isLoading
}) => {
  return (
    <Story bgColor="#fff">
      <StoryOrderBoxes>
        <StoryBox style={{ background: '#FFEAEF' }} />
        <StoryBox style={{ background: '#E51A4D' }} />
        <StoryBox style={{ background: '#FFEAEF' }} />
        <StoryBox style={{ background: '#FFEAEF' }} />
      </StoryOrderBoxes>
      <StoryHeading bg="#FFEAEF" color="#E51A4D">
        <div>2</div> <h1>Write & earn money</h1>
      </StoryHeading>
      <StoryHead2 fs="30px" color="#000">
        Let your imagination{' '}
        <span style={{ textDecoration: 'line-through #FF1F1FCC' }}>
          run wild
        </span>{' '}
        <span style={{ color: '#E51A4D' }}>make money</span>{' '}
      </StoryHead2>
      <StoryHead3 color="#000">Monetise words & start earning...</StoryHead3>
      <EnglishStory2Img>
        <LeftDiv onClick={() => handleStoryChange('prev')} ></LeftDiv>
        <RightDiv onClick={() => handleStoryChange('next')}></RightDiv>
        <img
          src="https://djhonz7dexnot.cloudfront.net/a40b7ef0a05281326f009f8484acb9d29ff206ca.png"
          alt="Write & Earn Money"
        />
      </EnglishStory2Img>
      <NextBtnContainer>
        <NextBtn
          bg="#FFEAEF"
          color="#E51A4D"
          type="button"
          onClick={() => handleStoryChange('next')}
        >
          NEXT <img src="/images/next_arrow_red.svg" alt=">>" />
        </NextBtn>
      </NextBtnContainer>

      <CTABtn bg="#E51A4D" color="#FFFFFF" onClick={handleStartWritingCTA}>
        {isLoading ? <Loader size="sm" noPadding invertColor /> : (<><img src="/images/writing_hand_white.svg" alt="✍🏼" /> Start Writing</>)}
      </CTABtn>
    </Story>
  )
}
const EnglishStory3 = ({
  handleStoryChange = () => {},
  handleStartWritingCTA,
  isLoading
}) => {
  return (
    <Story bgColor="#E51A4D">
      <StoryOrderBoxes>
        <StoryBox />
        <StoryBox />
        <StoryBox on />
        <StoryBox />
      </StoryOrderBoxes>
      <StoryHeading>
        <div>3</div> <h1>Build a global fan base</h1>
      </StoryHeading>
      <StoryHead2 fs="30px">Write your stories & speak to the world</StoryHead2>
      <StoryHead3>Make your audio blockbuster....</StoryHead3>
      <EnglishStory3Img>
        <LeftDiv onClick={() => handleStoryChange('prev')} ></LeftDiv>
        <RightDiv onClick={() => handleStoryChange('next')}></RightDiv>
        <img
          src="https://djhonz7dexnot.cloudfront.net/78e929aa39c6f2b5f7f05c82a6699aa5d8274c40.png"
          alt="Build a Global Fan Base"
        />
      </EnglishStory3Img>
      <NextBtnContainer>
        <NextBtn type="button" onClick={() => handleStoryChange('next')}>
          NEXT <img src="/images/next_arrow.svg" alt=">>" />
        </NextBtn>
      </NextBtnContainer>
      <CTABtn color="#E51A4D" onClick={handleStartWritingCTA}>
        {isLoading ? <Loader size="sm" noPadding /> : (<><img src="/images/writing_hand_red.svg" alt="✍🏼" /> Start Writing</>)}
      </CTABtn>
    </Story>
  )
}
const EnglishStory4 = ({ handleStartWritingCTA, isLoading, handleStoryChange }) => {
  return (
    <Story bgColor="#FFF">
      <StoryOrderBoxes>
        <StoryBox style={{ background: '#FFEAEF' }} />
        <StoryBox style={{ background: '#FFEAEF' }} />
        <StoryBox style={{ background: '#FFEAEF' }} />
        <StoryBox style={{ background: '#E51A4D' }} />
      </StoryOrderBoxes>
      <StoryHeading bg="#FFEAEF" color="#E51A4D">
        <div>4</div> <h1>You have our support</h1>
      </StoryHeading>
      <StoryHead2 fs="30px" color="#000">
        Editorial guidance &{' '}
        <span style={{ color: '#E51A4D' }}>community support</span>
      </StoryHead2>
      <StoryHead3 color="#000">Keys to an audio masterpiece...</StoryHead3>
      <EnglishStory4Img>
        <LeftDiv onClick={() => handleStoryChange('prev')} ></LeftDiv>
        <RightDiv onClick={() => handleStoryChange('next')}></RightDiv>
        <img
          src="https://djhonz7dexnot.cloudfront.net/cb053ceee289ae6e4cffeece52cda4f7a719f20e.png"
          alt="Build a Global Fan Base"
        />
      </EnglishStory4Img>
      <CTABtn bg="#E51A4D" color="#FFFFFF" onClick={handleStartWritingCTA}>
        {isLoading ? <Loader size="sm" noPadding invertColor /> : (<><img src="/images/writing_hand_white.svg" alt="✍🏼" /> Start Writing</>)}
      </CTABtn>
    </Story>
  )
}

const WelcomePages = ({ user }) => {
  const [story, setStory] = useState(user?.languages === 'hindi' ? 'hindi_1' : 'english_1')
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    handleEventLog('onboarding_value_prop', 'page_load', {
      module_name : story,
      entity_id : story[story.length - 1],
      entity_type: 'onboarding_screen',
    })
  }, [story])

  const handleStoryChange = (direction) => {
    handleEventLog('onboarding_value_prop', 'button_click', {
      module_name : story,
      entity_id : story[story.length - 1],
      entity_type: 'onboarding_screen',
      view_id: direction || 'Next'
    })
    if (direction === 'next'){
      if (story === 'hindi_1') setStory('hindi_2')
      if (story === 'hindi_2') setStory('hindi_3')
      if (story === 'english_1') setStory('english_2')
      if (story === 'english_2') setStory('english_3')
      if (story === 'english_3') setStory('english_4')
    }
    else {
      if (story === 'hindi_2') setStory('hindi_1')
      if (story === 'hindi_3') setStory('hindi_2')
      if (story === 'english_2') setStory('english_1')
      if (story === 'english_3') setStory('english_2')
      if (story === 'english_4') setStory('english_3')
    }
  }

  const handleStartWritingCTA = async () => {
    setLoading(true)
    handleEventLog('onboarding_value_prop', 'button_click', {
      module_name : story,
      entity_id : story.at(-1),
      entity_type: 'onboarding_screen',
      view_id: 'Start Writing'
    })
    const coverFile = await getImageUrl('Untitled Book 1', user?.fullname)
    const isUgcUser = user?.location !== 'IN' && user?.languages === 'english'
    uploadFile(coverFile, 'Untitled Book 1', null, isUgcUser, true)
  }

  return (
    <MainDiv>
      {story === 'hindi_1' && (
        <HindiStory1
          handleStoryChange={handleStoryChange}
          handleStartWritingCTA={handleStartWritingCTA}
          isLoading={isLoading}
        />
      )}
      {story === 'hindi_2' && (
        <HindiStory2
          handleStoryChange={handleStoryChange}
          handleStartWritingCTA={handleStartWritingCTA}
          isLoading={isLoading}
        />
      )}
      {story === 'hindi_3' && (
        <HindiStory3
          handleStoryChange={handleStoryChange}
          handleStartWritingCTA={handleStartWritingCTA}
          isLoading={isLoading}
        />
      )}
      {story === 'english_1' && (
        <EnglishStory1
          handleStoryChange={handleStoryChange}
          handleStartWritingCTA={handleStartWritingCTA}
          isLoading={isLoading}
        />
      )}
      {story === 'english_2' && (
        <EnglishStory2
          handleStoryChange={handleStoryChange}
          handleStartWritingCTA={handleStartWritingCTA}
          isLoading={isLoading}
        />
      )}
      {story === 'english_3' && (
        <EnglishStory3
          handleStoryChange={handleStoryChange}
          handleStartWritingCTA={handleStartWritingCTA}
          isLoading={isLoading}
        />
      )}
      {story === 'english_4' && (
        <EnglishStory4
          handleStoryChange={handleStoryChange}
          handleStartWritingCTA={handleStartWritingCTA}
          isLoading={isLoading}
        />
      )}
    </MainDiv>
  )
}

export default WelcomePages
